import './index.css';

// import ExceptionImg from '../../assets/logo-header.svg';
import { Component } from 'react';
import logo from '../../assets/icons/ai-logo.svg';
import logotype from '../../assets/icons/ai-admin-logotype.svg';

interface ExceptionProps {
  location?: {
    pathname: string;
  };
}

interface ExceptionState {
  errorCode: number | null;
  errorMsg: string;
}

class Exception extends Component<ExceptionProps, ExceptionState> {
  constructor(props: ExceptionProps) {
    super(props);
    this.state = {
      errorCode: null,
      errorMsg: '',
    };
  }

  componentDidMount() {
    let code = 404;
    let msg = 'Sorry, the page you visited does not exist';

    if (this.props.location?.pathname.split('/')[1] === 'exception') {
      code = parseInt(this.props.location.pathname.split('/')[2], 10);
      msg = 'Sorry, the server is reporting an error';
    }
    this.setState({
      errorCode: code,
      errorMsg: msg,
    });
  }

  render() {
    const { errorCode, errorMsg } = this.state;
    return (
      <div className="page-not-found-container">
        <div className="main">
          <div className="left">
            <div className="header">
              <img className="logo" src={logo} alt="logo" />
              <img className="logotype" src={logotype} alt="logotype" />
            </div>
          </div>
          <div className="right">
            <h1>{errorCode}</h1>

            <div className="not-found-subtext">{errorMsg}</div>

            <button type="submit" className="not-found-button">
              <div className="link">
                <a href="/">Back to Home</a>
              </div>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Exception;
